<template>
  <a v-if="isDeletable" data-toggle="modal" @click="deletedData" :class="[options.class, 'delete-icon-link']"
    :data-target="options.target">
    <i class="ag-icon ag-icon_delete" data-toggle="tooltip" title="Delete"></i>
  </a>
</template>

<script setup>
import { defineEmits, defineProps, computed } from "vue";

const emit = defineEmits(['deleteClick'])
const props = defineProps({
  data: {
    type: Array,
    default: null,
  },
  options: {
    type: Object,
    default: null,
  },
})

const nonDeletableNames = new Set([
  'Restricted (TPL)',
  'Allow List',
  'Prohibited',
  'Standard Containment',
  'Private Containment',
  'Power Apps',
])

const isDeletable = computed(() => {
  const name = props?.data?.name?.trim()
  if (!name) return true
  return !nonDeletableNames.has(name)
})

function deletedData() {
  emit('deleteClick', props.data)
}
</script>
<style>
.delete-icon-link {
  cursor: pointer;
}
.ag-icon_delete{
  font-size: 1em !important;
}
</style>